var showdown = require('showdown');

// Netlify CMS's markdown editor writes hard line breaks as a trailing
// backslash (CommonMark), which showdown doesn't understand. Convert them to
// the two-space form showdown does support before rendering.
export default class MarkdownConverter {
  constructor() {
    this.converter = new showdown.Converter();
  }

  makeHtml(text) {
    return this.converter.makeHtml((text || '').replace(/\\\r?\n/g, '  \n'));
  }
}
